import { Colors } from "@zapier/design-system";
import styles from "./PointerIcon.module.css";

type Props = {
  isSelected: boolean;
};

export function PointerIcon({ isSelected }: Props) {
  const fill = isSelected ? Colors.UiPrimaryStrongest : Colors.GrayWarm5;
  return (
    <span className={styles.pointerIcon}>
      <svg
        width="16"
        height="24"
        viewBox="0 0 18 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0V24L6.36214 17.852L6.705 17.5538L17.4964 17.5714L0 0Z"
          fill={fill}
        />
      </svg>
    </span>
  );
}
